import { request } from '@/utils/request'
import { update } from 'lodash-es'

// 授权接口
const miniAppApi = {

  /** 获取小程序列表 **/
  list: params => request.get('wechat/mini_app', params),

  /** 获取小程序详情 **/
  detail: id => request.get(`wechat/mini_app/${id}`),

  /** 同步已授权小程序 **/
  syncAuthMiniApp: () => request.post('wechat/mini_app/sync'),

  /** 回退小程序版本 **/
  revertAudit: subAppid => request.post(`wechat/mini_app/code/${subAppid}/revert_audit`),

  // /** 批量回退小程序版本 **/
  // batchRevertAudit: params => request.post('wechat/mini_app/code/revert_audit/batch', params),


  /** 提交历史 **/
  commitHistory: subAppid => request.get('wechat/mini_app/versions', { weappId: subAppid }),

  /** 批量设置服务器域名 **/
  updateServerDomain: params => request.post('wechat/mini_app/domain/domain/batch', params),

  /** 批量设置业务域名 **/
  updateBusinessDomain: params => request.post('/wechat/mini_app/domain/web_view_domain/batch', params),

  /** 获取第三方平台服务器域名 */
  getThirdServerDomain: () => request.get('wechat/open_platform/domain/third_party_server_domain'),

  /** 添加第三方平台服务器域名 */
  setThirdServerDomain: params => request.post('wechat/open_platform/domain/third_party_server_domain', params),

  /** 获取第三方平台业务域名 */
  getThirdBusinessDomain: () => request.get('wechat/open_platform/domain/third_party_jump_domain'),

  /** 添加第三方平台业务域名 */
  setThirdBusinessDomain: params => request.post('wechat/open_platform/domain/third_party_jump_domain', params),

  /** 代注册小程序 */
  registerMiniapp: params => request.post('wechat/register/miniprogram', params),

  /** 体验版二维码 */
  testQrcode: subAppid => request.get(`wechat/mini_app/code/${subAppid}/trial_qrcode`),

  /** 更新小程序信息 */
  updateMiniAppInfo: id => request.put(`wechat/mini_app/${id}`),

  /** 撤回审核 */
  undoAudit: subAppid => request.post(`wechat/mini_app/code/${subAppid}/undo_audit`)
}

export { miniAppApi }


